import React from "react";
import { Form } from "semantic-ui-react";
import { injectIntlHelperHOC } from "../intl-helper";

const jobs = intlh => [
  { key: "empty", text: "", value: "" },
  { key: "a", text: intlh("survey.jobs.architecture"), value: "Architecture" },
  { key: "c", text: intlh("survey.jobs.cad"), value: "CAD" },
  { key: "e", text: intlh("survey.jobs.education"), value: "Education" },
  { key: "g", text: intlh("survey.jobs.graphics"), value: "Graphics" },
  { key: "m", text: intlh("survey.jobs.management"), value: "Management" },
  { key: "so", text: intlh("survey.jobs.sw"), value: "Development" },
  { key: "su", text: intlh("survey.jobs.support"), value: "Support" },
  { key: "t", text: intlh("survey.jobs.test"), value: "Test" },
  { key: "o", text: intlh("survey.jobs.other"), value: "Other" },
];

const JobListDropdownInternal = ({ intlh, ...others }) => (
  <Form.Select options={jobs(intlh)} {...others} />
);

export const JobListDropdown = injectIntlHelperHOC(JobListDropdownInternal);
